<template>
  <el-form
    :model="addForm"
    ref="addForm"
    label-width="120px"
    :hide-required-asterisk="false"
    class="form"
    :inline="true"
    id="add-program"
  >
    <el-row>
      <el-col :span="24">
        <el-tabs
          v-model="activeName"
          v-if="mxParams.type == 1 || mxParams.weeklyTime == 2"
        >
          <el-tab-pane label="自定义推送" name="first">
            <el-table
              :data="list"
              fit
              v-loading="loading"
              highlight-current-row
              :default-sort="{ prop: 'date', order: 'descending' }"
              tooltip-effect="dark"
            >
              <el-table-column
                fixed
                label="操作"
                min-width="100px"
                align="center"
                class-name="small-padding fixed-width"
                :render-header="renderHeader"
              >
                <template slot-scope="scope">
                  <!--<el-button-->
                  <!--type="text"-->
                  <!--@click="handleCopyRow(scope.row)"-->
                  <!--size="mini"-->
                  <!--&gt;复制</el-button-->
                  <!--&gt;-->
                  <el-button
                    type="text"
                    @click="handleDelRow(scope.$index, list)"
                    size="mini"
                    >删除</el-button
                  >
                </template>
              </el-table-column>

              <el-table-column
                label="工作内容"
                align="left"
                prop="customExecutor"
                min-width="400px"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <el-autocomplete
                    popper-class="my-autocomplete"
                    v-model="scope.row.work"
                    :fetch-suggestions="querySearch"
                    placeholder="请输入内容"
                    @select="
                      (e) => {
                        handleSelect(e, scope.row.index);
                      }
                    "
                  >
                    <i class="el-icon-edit el-input__icon" slot="suffix"> </i>
                    <template slot-scope="{ item }">
                      <div class="name">{{ item.name }}</div>
                    </template>
                  </el-autocomplete>
                  <!-- <el-select
                v-model="scope.row.work"
                filterable
                allow-create
                default-first-option
                :multiple="false"
                style="width: 380px"
                :collapse-tags="true"
                class="filter-item"
                placeholder="请输入工作内容或者选择计划任务，按回车确认"
                clearable
              >
                <el-option
                  v-for="item in worksList"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select> -->
                </template>
              </el-table-column>

              <el-table-column
                label="责任人"
                align="left"
                prop="fzr"
                min-width="300px"
                :show-overflow-tooltip="true"
                :key="refresh"
              >
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.executor"
                    filterable
                    default-first-option
                    :multiple="true"
                    style="width: 290px"
                    :collapse-tags="true"
                    class="filter-item"
                    placeholder="请选择责任人"
                    @change="$forceUpdate()"
                    @input="
                      (e) => {
                        handleClick(e, scope.row);
                      }
                    "
                  >
                    <el-option
                      v-for="item in fzrList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <template slot="empty">
                <div class="nodata">
                  <img src="@/img/nodata.png" alt="" width="160" />
                  <div>暂无数据</div>
                </div>
              </template>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="导入文件推送" name="second">
            <div>
              <el-table
                :data="zbfj"
                fit
                v-loading="loading"
                highlight-current-row
                :default-sort="{ prop: 'date', order: 'descending' }"
                tooltip-effect="dark"
              >
                <el-table-column
                  fixed
                  label="操作"
                  min-width="100px"
                  align="center"
                  class-name="small-padding fixed-width"
                >
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click="handleDelZbfj(scope.row.fileid, scope.row.url)"
                      size="mini"
                      >删除</el-button
                    >
                    <el-button
                      type="text"
                      @click="handleViewFile(scope.row)"
                      size="mini"
                      >预览</el-button
                    >
                  </template>
                </el-table-column>

                <el-table-column
                  label="已上传的周报"
                  align="center"
                  prop="name"
                  min-width="400px"
                  :show-overflow-tooltip="true"
                >
                </el-table-column>
                <template slot="empty">
                  <div class="nodata">
                    <img src="@/img/nodata.png" alt="" width="160" />
                    <div>暂无数据</div>
                  </div>
                </template>
              </el-table>
            </div>
            <div class="upload-btn">
              <el-upload
                action="#"
                class="upload-demo"
                ref="upload"
                :headers="headers"
                :on-change="handleChange"
                :file-list="fileList"
                :auto-upload="false"
                :on-exceed="handleExceed"
                multiple
                :limit="1"
              >
                <el-button type="primary" icon="el-icon-upload" plain
                  >选择文件</el-button
                >
              </el-upload>
              <div class="upload-tips">
                (单个文件不能超过5M，支持word文档上传)
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div v-else>
          <el-table
            :data="list"
            fit
            v-loading="loading"
            highlight-current-row
            :default-sort="{ prop: 'date', order: 'descending' }"
            tooltip-effect="dark"
          >
            <el-table-column
              fixed
              label="操作"
              min-width="100px"
              align="center"
              class-name="small-padding fixed-width"
              :render-header="renderHeader"
            >
              <template slot-scope="scope">
                <!--<el-button-->
                <!--type="text"-->
                <!--@click="handleCopyRow(scope.row)"-->
                <!--size="mini"-->
                <!--&gt;复制</el-button-->
                <!--&gt;-->
                <el-button
                  type="text"
                  @click="handleDelRow(scope.$index, list)"
                  size="mini"
                  >删除</el-button
                >
              </template>
            </el-table-column>

            <el-table-column
              label="工作内容"
              align="left"
              prop="customExecutor"
              min-width="400px"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <el-autocomplete
                  popper-class="my-autocomplete"
                  v-model="scope.row.work"
                  :fetch-suggestions="querySearch"
                  placeholder="请输入内容"
                  @select="
                    (e) => {
                      handleSelect(e, scope.row.index);
                    }
                  "
                >
                  <i class="el-icon-edit el-input__icon" slot="suffix"> </i>
                  <template slot-scope="{ item }">
                    <div class="name">{{ item.name }}</div>
                  </template>
                </el-autocomplete>
                <!-- <el-select
                v-model="scope.row.work"
                filterable
                allow-create
                default-first-option
                :multiple="false"
                style="width: 380px"
                :collapse-tags="true"
                class="filter-item"
                placeholder="请输入工作内容或者选择计划任务，按回车确认"
                clearable
              >
                <el-option
                  v-for="item in worksList"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select> -->
              </template>
            </el-table-column>

            <el-table-column
              label="责任人"
              align="left"
              prop="fzr"
              min-width="300px"
              :show-overflow-tooltip="true"
              :key="refresh"
            >
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.executor"
                  filterable
                  default-first-option
                  :multiple="true"
                  style="width: 290px"
                  :collapse-tags="true"
                  class="filter-item"
                  placeholder="请选择责任人"
                  @change="$forceUpdate()"
                  @input="
                    (e) => {
                      handleClick(e, scope.row);
                    }
                  "
                >
                  <el-option
                    v-for="item in fzrList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="nodata">
                <img src="@/img/nodata.png" alt="" width="160" />
                <div>暂无数据</div>
              </div>
            </template>
          </el-table>
        </div>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { deepClone } from "@/utils/utils";
import moment from "moment";
import "moment/locale/zh-cn";
import { mapGetters } from "vuex";
import {
  getPushXmzb,
  getKhfzrs,
  pushXmzbSave,
  zbUpload,
  fileDelete,
} from "@/api/weekly.js";
export default {
  name: "Push",
  components: { Treeselect },
  computed: {},
  props: ["mxParams"],
  data() {
    return {
      headers: {
        "x-token": localStorage.getItem("token"),
      },
      list: [],
      loading: false,
      parentDialog: false,
      addForm: {},
      fzrList: [],
      worksList: [],
      refresh: false,
      activeName: "first",
      fileList: [],
      zbfj: [],
      // worksList: [],
    };
  },
  created() {
    // let nextWeek = moment().add(1, "weeks").format("YYYYMMDD");
    // this.mxParams.nextWeekDate =
    //   moment(nextWeek).startOf("week").format("YYYYMMDD") +
    //   "-" +
    //   moment(nextWeek).endOf("week").format("YYYYMMDD");
    // if (this.mxParams.type == 2) {
    //   this.mxParams.xmzq = this.mxParams.nextWeekDate;
    // }
    this.getData();
    getKhfzrs(this.mxParams.xmbh).then((res) => {
      if (res.code == 0) {
        this.fzrList = res.data;
      }
    });
  },
  mounted() {},
  methods: {
    getData() {
      getPushXmzb(
        this.mxParams.xmbh,
        this.mxParams.xmzq,
        this.mxParams.type
      ).then((res) => {
        if (res.code == 0) {
          this.worksList = res.data.tasks;
          this.list = res.data.works;
          this.zbfj = res.data.zbfj;
          for (let i = 0; i < this.list.length; i++) {
            let executorStr = [];
            let executorStr1 = this.list[i].executor1;
            let executorStr2 = this.list[i].executor2;
            if (executorStr1 != "") {
              executorStr.push(...executorStr1.split(","));
            }
            if (executorStr2 != "") {
              executorStr.push(...executorStr2.split(","));
            }
            if (executorStr.length > 0) {
              this.list[i].executor = executorStr;
            } else {
              this.list[i].executor = null;
            }
            this.list[i].index = i;
          }
        }
      });
    },
    handleCopyRow(row) {
      if (!row) {
        this.list.push({
          work: null,
          executor: null,
          index: this.list.length,
        });
        return;
      }
      const newRow = deepClone(row);
      if (row.time && row.time.length > 0) {
        newRow.time = [
          moment(row.time[0]).format("YYYY-MM-DD"),
          moment(row.time[1]).format("YYYY-MM-DD"),
        ];
      }
      this.list.push(newRow);
    },

    handleDelRow(index, rows) {
      rows.splice(index, 1);
    },
    handleChangeModal(e) {
      if (!e) {
        //隐藏时触发
        let node = this.$refs["cascaderModal"].getCheckedNodes();

        if (node.length > 0) {
          //去重
          for (let i in node) {
            for (let j in this.list) {
              if (node[i].value == this.list[j].link_point) {
                node.splice(i, 1);
              }
            }
          }
        }
        if (node.length > 0) {
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
          }, 1000);
          //表格批量新增
          for (let i in node) {
            this.list.push({
              work: null,
              executor: null,
            });
          }
        }
      }
    },
    handleInsert() {
      if (this.activeName == "second") {
        this.submitUpload();
      } else {
        const list = deepClone(this.list);
        for (let i in list) {
          list[i].xmbh = this.mxParams.xmbh;
          list[i].type = this.mxParams.type;
          list[i].xmzq = this.mxParams.xmzq;
          list[i].id = list[i].id;
          let work = list[i].work;
          if (!work) {
            this.$message.error("工作内容必填项！");
            return;
          }
          let executor = list[i].executor.join(",");
          if (!executor) {
            this.$message.error("负责人都为必填项！");
            return;
          }
          list[i].work = list[i].work.toString();
          list[i].executor = list[i].executor.join(",");
        }
        for (let i in list) {
          for (let j in list) {
            if (i !== j) {
              const isEqual = this.isObjectEqual(list[i], list[j]);
              if (isEqual) {
                this.$message.error("存在重复记录!");
                return;
              }
            }
          }
        }
        pushXmzbSave(list).then((res) => {
          if (res.code == 0) {
            this.$message.success(res.msg);
            this.$emit("giveFather", this.parentDialog);
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    isObjectEqual(obj1, obj2) {
      let o1 = obj1 instanceof Object;
      let o2 = obj2 instanceof Object;
      if (!o1 || !o2) {
        // 如果不是对象 直接判断数据是否相等
        return obj1 === obj2;
      }
      // 判断对象的可枚举属性组成的数组长度
      if (Object.keys(obj1).length !== Object.keys(obj2).length) {
        return false;
      }
      for (let attr in obj1) {
        let a1 =
          Object.prototype.toString.call(obj1[attr]) == "[object Object]";
        let a2 =
          Object.prototype.toString.call(obj2[attr]) == "[object Object]";
        let arr1 =
          Object.prototype.toString.call(obj1[attr]) == "[object Array]";
        if (a1 && a2) {
          // 如果是对象继续判断
          return isObjectEqual(obj1[attr], obj2[attr]);
        } else if (arr1) {
          // 如果是对象 判断
          if (obj1[attr].toString() != obj2[attr].toString()) {
            return false;
          }
        } else if (obj1[attr] !== obj2[attr]) {
          // 不是对象的就判断数值是否相等
          return false;
        }
      }
      return true;
    },
    renderHeader() {
      return (
        <el-button size="small" on-click={() => this.handleCopyRow(null)}>
          操作<span class="el-icon-plus"></span>
        </el-button>
      );
    },
    handleClick() {
      this.refresh = !this.refresh;
    },
    querySearch(queryString, cb) {
      var worksList = this.worksList;
      var results = queryString
        ? worksList.filter(this.createFilter(queryString))
        : worksList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    handleSelect(e, index) {
      this.list[index].work = e.name;
    },

    handleChange(file, fileList) {
      // 验证上传文件的格式
      const suffixReg = /(doc|docx)$/;
      const point = file.name.lastIndexOf(".");
      const suffix = file.name.substr(point + 1);
      const isFile = suffixReg.test(suffix);
      if (!isFile) {
        this.$message.error("请上传正确格式的文件 !");
        fileList.pop();
        return false;
      }

      // 验证文件大小
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error(file.name + "文件大小超出限制，请修改后重新上传");
        fileList.pop();
        return false;
      }
    },
    handleExceed(files, fileList) {
      this.$message.error(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    submitUpload(isCxfqps) {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          let { uploadFiles } = this.$refs.upload;
          let fileLen = uploadFiles.length;
          let form = new FormData();
          uploadFiles.forEach((item, index) => {
            form.append("files", item.raw);
          });

          if (fileLen > 0) {
            //上传文件
            form.append("xmbh", this.mxParams.xmbh);
            form.append("xmzq", this.mxParams.xmzq);
            form.append("type", this.mxParams.type);
            return new Promise((resolve, reject) => {
              zbUpload(form)
                .then((res) => {
                  if (res.code == 0) {
                    if (!isCxfqps) {
                      this.$message.success("上传成功！");
                    }
                  } else {
                    this.$message({
                      type: "error",
                      message: res.msg,
                      showClose: true,
                    });
                  }
                  resolve(res);
                })
                .catch((err) => {
                  reject(err);
                });
            }).then((success) => {
              if (success.code == 0) {
                this.$emit("giveFather", this.parentDialog);
              }
            });
          } else if (fileLen == 0) {
            this.$message.error("请上传周报！");
            return false;
          } else {
            this.$message.error(res.msg);
            return false;
          }
        } else {
          this.$message.error("请输入表单必填字段！");
        }
      });
    },
    handleDelZbfj(fileId, url) {
      fileDelete({ fileId, absolutePath: url }).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.getData();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleViewFile(row) {
      // sessionStorage.setItem("previewurl", row.previewurl);
      // let routeData = this.$router.resolve({
      //   path: "/officePreview",
      //   component: () => import("@/views/zxlc/officePreview/index"),
      // });
      // window.open(routeData.href, "_blank");
      const url = row.previewurl;
      window.open(url);
    },
  },
};
</script>
<style lang="less" scoped>
.form {
  padding: 15px;
}
.upload-btn {
  text-align: center;
  margin-top: 10px;
}
.upload-tips {
  margin-top: 10px;
}
</style>